'use strict';
angular.module('qms.controllers', [])


.controller('view3dCtrl',['$scope','$rootScope','$location','ArraySvce',function ($scope, $rootScope, $location, arraySvce) {

  //

}])

.controller('condemnationsCtrl',['$scope','$rootScope','$location','ArraySvce',function ($scope, $rootScope, $location, arraySvce) {

  //

}])

.controller('weightCtrl',['$scope','$rootScope','$location','ArraySvce',function ($scope, $rootScope, $location, arraySvce) {

  $scope.viewState = {
    content: "weight_issues",
    tmplt: null
  };

  $scope.toggleContent = function(tmplt) {
    $scope.viewState.content = tmplt;
  };

  $scope.$watch('viewState.content',function(val) {
    var t =   val+".html";
    $scope.viewState.tmplt = t;
  });

}])

.controller('dirtyCtrl',['$scope','$rootScope','$location','ArraySvce',function ($scope, $rootScope, $location, arraySvce) {

  $scope.viewState = {
    content: "dirty-livestock-accepted",
    tmplt: null
  };

  $scope.toggleContent = function(tmplt) {
    $scope.viewState.content = tmplt;
  };

  $scope.$watch('viewState.content',function(val) {
    var t =   val+".html";
    $scope.viewState.tmplt = t;
  });

}])

.controller('gridIntroCtrl',['$scope','$location','ArraySvce',function ($scope, $location, arraySvce) {

  $scope.curNavState.mainGridSel.beef = $scope.gridNav.beef.defaultVal.main;
  $scope.curNavState.mainGridSel.lamb = $scope.gridNav.lamb.defaultVal.main;

  $scope.carcaseData = {
    cPath: null,
    cVal: null,
    cText: null,
    fPath: null,
    fVal: null,
    fText: null
  };

  $scope.$watch('curNavState.beast',function(val) {
    //
  });

  $scope.mainGrid = {
    ready: false
  };

  var setCarcaseData = function() {
    var axis = 'f';
    var v = '4';
    $scope.carcaseData.cVal = $scope.curNavState.mainGridSel[$scope.curNavState.beast].slice(0,1);
    $scope.carcaseData.fVal = $scope.curNavState.mainGridSel[$scope.curNavState.beast].slice(1,2);
    $scope.carcaseData.cPath = 'img/'+$scope.curNavState.beast+'_carcase_c_'+$scope.carcaseData.cVal+'.jpg';
    $scope.carcaseData.fPath = 'img/'+$scope.curNavState.beast+'_carcase_f_'+$scope.carcaseData.fVal+'.jpg';

    $scope.carcaseData.cText = {
      content: [
        {
          headline: 'Conformation: '+$scope.carcaseData.cVal,
          bullets: $scope.gridIntroText.conformation[$scope.carcaseData.cVal]
        }
      ]
    };

    $scope.carcaseData.fText = {
      content: [
        {
          headline: 'Fat: ' + $scope.carcaseData.fVal,
          bullets: $scope.gridIntroText.fat[$scope.carcaseData.fVal]
        }
      ]
    };

  };

  $scope.$watch('curNavState',function(val) {
    setCarcaseData();
  },true);

  $scope.clickMainGrid = function(sel) {
    $scope.curNavState.mainGridSel[$scope.curNavState.beast] = sel;
  }

  $scope.gridKey = {
    show:false
  }

  $scope.toggleGridKey = function() {
    $scope.gridKey.show = !$scope.gridKey.show;
  }

}])

.controller('handlingCtrl',['$scope','$rootScope','$window','$document','$location','ArraySvce',function ($scope, $rootScope, $window, $document, $location, arraySvce) {

  $scope.handlingImg = {
    beef: 'img/beef_handling.jpg',
    lamb: 'img/lamb_handling.jpg'
  };

  $scope.showPoints = {
    fat: false,
    conformation: false
  };

  $scope.labelOffset - {
    x: 12,
    y: 0
  }

  $scope.togglePoints = function(p) {
    $scope.showPoints[p] = !$scope.showPoints[p];
  }

  $scope.imgContainer = {
    aspect: 1,
    w: 0,
    h: 0
  }

  var doResize = function() {

    $scope.$apply(function() {
      var c = angular.element($document[0].querySelector('#handling_wrap'));
      $scope.imgContainer.w = c[0].offsetWidth;
      $scope.imgContainer.h = c[0].clientHeight;
      $scope.imgContainer.aspect =   $scope.imgContainer.h / $scope.imgContainer.w;
    });

  }

  angular.element($window).bind('resize', function () {
    doResize();
  });

  setTimeout(function() {
    doResize();
  },60);

  $scope.$on("$destroy", function() {
    angular.element($window).unbind('resize');
  });

}])


.controller('virtBeastCtrl',['$scope','$rootScope','$location','ArraySvce','DataObj',function ($scope, $rootScope, $location, arraySvce, dataObj) {


  $scope.curNavState.gridSel.beef = $scope.gridNav.beef.defaultVal.virtual;
  $scope.curNavState.gridSel.lamb = $scope.gridNav.lamb.defaultVal.virtual;

  $scope.virtualObjList = [];

  $scope.makeVirtualObjList = function() {

    const beast = $scope.curNavState.beast;
    const grades = $scope.gridNav[beast].main;
    const fType = "fbx";
    const fPath = "obj";
    const capB = beast.charAt(0).toUpperCase() + beast.slice(1);

    var baseObj = {
      loaded: {
        complete: false,
        progress: 0,
        percent: 0
      },
      id: 'virtual_beast_'+beast,
      models: {}
    };

    var objList = grades.map(function(val) {
      var n = val.replace('+','_plus_').replace('-','minus_');
      var tmpObj = {
        visible: $scope.curNavState.gridSel[beast] == val ? true : false,
        opacity:1,
        id: capB+" "+n,
        name: capB+"_"+n,
        path: fPath+"/"+capB+"_"+n+"."+fType
      }
      var obj = Object.assign(tmpObj,$scope.set3d.defaultModelSettings[$scope.curNavState.beast]);
      return obj;
    });

    baseObj.models = objList;

    var loaded = {
      complete: false,
      progress: 0,
      percent: 0
    };

    $scope.virtualObjList = Object.assign({},baseObj);

    $scope.curNavState.updateModels = true;

  };

  $scope.$watch('curNavState.beast',function(val) {
    $scope.makeVirtualObjList();
  });

  $scope.makeVirtualObjList();

  $scope.toggleVis = function(name) {

          const capB = $scope.curNavState.beast.charAt(0).toUpperCase() + $scope.curNavState.beast.slice(1);
          const n = capB+'_'+name;
          var idx = arraySvce.arrIndexOf($scope.virtualObjList.models,n,'name');

          if(idx > -1) {
            for(var i=0;i<$scope.virtualObjList.models.length;i++) {
              if(i == idx) {
                //console.log('yes '+$scope.virtualObjList.models[i].name);
                $scope.virtualObjList.models[i].visible = true;
              }
              else {
                //console.log('no '+$scope.virtualObjList.models[i].name);
                $scope.virtualObjList.models[i].visible = false;
              }
            };
          }
          $scope.curNavState.gridSel[$scope.curNavState.beast] = name;
  };

}])

.controller('assessCtrl',['$scope','$rootScope','$location','ArraySvce','DataObj',function ($scope, $rootScope, $location, arraySvce, dataObj) {

  $scope.curNavState.gridSel.beef = $scope.gridNav.beef.defaultVal[$scope.curNavState.assess];
  $scope.curNavState.gridSel.lamb = $scope.gridNav.lamb.defaultVal[$scope.curNavState.assess];;

  var initSlider = function() {
    var keyList = $scope.gridNav[$scope.curNavState.beast][$scope.curNavState.assess];
    var defaultKey = $scope.gridNav[$scope.curNavState.beast].defaultVal[$scope.curNavState.assess];
      $scope.sliderArgs = Object.assign({},dataObj.sliderDefaults());
      $scope.sliderState = Object.assign({},dataObj.sliderState());
      $scope.sliderArgs.keyNames = $scope.makeSliderKeyList(keyList);
      $scope.sliderState.nearKey = keyList.indexOf(defaultKey) + 1;
      $scope.sliderState.nearKeyLabel = defaultKey;
      setTimeout(function() {$scope.sliderState.loadState.ready = true},10);
  }

  $scope.assessObjList = []

  $scope.controls.enabled = false;

  $scope.assessNav = function(data) {
    $scope.curNavState.assess = data;
  };

  var arrValToFront = function(arr,val) {
    const idx = arr.indexOf(val);
    if(idx > -1) {
      const newArr = arr.slice(0,arr.length);
      newArr.splice(idx,1);
      newArr.unshift(val);
      return newArr;
    }
    else {
      return arr;
    }
  };

  $scope.makeAssessObjList = function() {
    const beast = $scope.curNavState.beast;
    const grades = arrValToFront($scope.gridNav[beast][$scope.curNavState.assess],$scope.curNavState.gridSel[beast]);
    const fType = "fbx";
    const fPath = "obj";
    const capB = beast.charAt(0).toUpperCase() + beast.slice(1);
    for(var i=0;i<$scope.assessPts.assess_pts[$scope.curNavState.assess].length;i++) {
        const type = $scope.assessPts.assess_pts[$scope.curNavState.assess][i];
        const posArgs = Object.assign($scope.assessPts.default,$scope.assessPts[beast][type]);
        var baseObj = {
          loaded: {
            complete: false,
            progress: 0,
            percent: 0
          },
          id: type,
          models: {}
        }
        var objList = grades.map(function(val) {
          var n = val.replace('+','_plus_').replace('-','minus_');
          var tmpObj = {
            visible: $scope.curNavState.gridSel[beast] == val ? true : false,
            opacity:1,
            id: capB+" "+n,
            name: capB+"_"+n,
            path: fPath+"/"+capB+"_"+n+"."+fType
          }
          var obj = Object.assign(tmpObj,posArgs);
          return obj;
        });
        baseObj.models = objList;
        var loaded = {
          complete: false,
          progress: 0,
          percent: 0
        };
        $scope.assessObjList[type] = Object.assign({},baseObj);

        $scope.curNavState.updateModels = true;
    }
  };

  $scope.toggleVis = function(name,pt) {
    const capB = $scope.curNavState.beast.charAt(0).toUpperCase() + $scope.curNavState.beast.slice(1);
    const n = capB+'_'+name;
    //console.log($scope.assessObjList[pt].models);
    var idx = arraySvce.arrIndexOf($scope.assessObjList[pt].models,n,'name');
    //console.log('name '+n+' idx '+idx);
    if(idx > -1) {
      for(var i=0;i<$scope.assessObjList[pt].models.length;i++) {
        if(i == idx) {
          console.log('yes '+$scope.assessObjList[pt].models[i].visible);
          $scope.assessObjList[pt].models[i].visible = true;
        }
        else {
          $scope.assessObjList[pt].models[i].visible = false;
        }
      };
    }
    $scope.curNavState.gridSel[$scope.curNavState.beast] = name;
  };

  $scope.$watch('curNavState.beast',function(val) {
    $scope.makeAssessObjList();
    initSlider();
  });

  $scope.$watch('curNavState.assess',function(val) {
    $scope.makeAssessObjList();
    initSlider();
  });

  $scope.$watch('sliderState.nearKey',function(val) {
    $scope.toggleVis($scope.sliderState.nearKeyLabel, $scope.assessPts.assess_pts[$scope.curNavState.assess][0]);
    $scope.toggleVis($scope.sliderState.nearKeyLabel, $scope.assessPts.assess_pts[$scope.curNavState.assess][1]);
    $scope.toggleVis($scope.sliderState.nearKeyLabel,  $scope.assessPts.assess_pts[$scope.curNavState.assess][2]);
  },true);

}])


.controller('mainCtrl',['$scope','$rootScope','$window','$document','$location','ArraySvce','ApiSvce','PreLoader','LocStore',function mainCtrl($scope, $rootScope, $window, $document, $location, arraySvce, apiSvce, preLoader, locStore) {

    //$scope.mainSite = window['main_site'].hostname;

    $scope.objList = {};
    $scope.set3d = {};
    $scope.gridNav = {};

    $scope.controls = {
      enabled: true
    }

    $scope.modelsLoaded = [];
    $scope.scenesLoaded = [];

    $scope.curViewState = {
      stickyFooter: true,
      navbarCollapsed: true
    }

    //$scope.navbarCollapsed = true;

    $scope.curNavState = {
      beast: 'beef',
      gridSel: {
        beef: 'R4L',
        lamb: 'R3H'
      },
      mainGridSel: {
        beef: 'R3',
        lamb: 'R3'
      },
      assess: 'fat',
      model: {},
      updateModels: false
    };

    var storedState = locStore.sessionGet("curNavState");

    if(storedState !== false) {
    //console.log('Retrieved session data');
      //console.log($scope.curNavState);
      //Object.assign($scope.curNavState, storedState);
    }

    $scope.currPage = {
      pgIdx: null,
      name: null,
      title: null,
      external: false,
      target: null,
      text_content: null
    };

    $scope.commentArgs = {
      show: false,
      name: null,
      email: null,
      comment: null,
      gdpr: 'YES',
      page: null
    }

    $scope.preLoadModels = function(list) {
      const THREE = $rootScope.THREE;
      const FBXLoader = $rootScope.FBXLoader;
      var loader = new FBXLoader();
      list.map(function(model) {
          loader.load(model,function(object) {
          console.log('preloaded model '+object.name);
        });
      });
    }

    $scope.goToRoute = function(name) {
      var pgIdx = arraySvce.arrIndexOf($scope.pages,name,'name');
      if(pgIdx >= 0 && pgIdx < $scope.pages.length) {
        $scope.currPage = {pgIdx:pgIdx};
        Object.assign($scope.currPage,  $scope.pages[pgIdx]);
        $location.path($scope.pages[pgIdx].target);
      };
    };

    $scope.goToPgIdx = function(pgIdx) {
      if(pgIdx >= 0 && pgIdx < $scope.pages.length) {
        Object.assign($scope.currPage,  $scope.pages[pgIdx]);
        $scope.currPage.pgIdx = pgIdx;
        $location.path($scope.pages[pgIdx].target);
      };
    };

    $scope.pageNext = function() {
      if($scope.currPage.pgIdx < $scope.pages.length -1) {
        $scope.goToPgIdx($scope.currPage.pgIdx+1)
      }
    };

    $scope.pagePrev = function() {
      if($scope.currPage.pgIdx > 0) {
        $scope.goToPgIdx($scope.currPage.pgIdx-1)
      }
    };

    $scope.selectGrid = function(sel) {
      $scope.curNavState.gridSel[$scope.curNavState.beast] = sel;
    };

    $scope.clickMainGrid = function(sel) {
      $scope.curNavState.gridSel[$scope.curNavState.beast] = sel;
    }

    $scope.homeNav = function(beast) {
      $scope.goToPgIdx(1);
      $scope.curNavState.beast = beast;
    }

    $scope.commentClick = function() {
      console.log("comment clicked");
      $scope.commentArgs.show = true;
      $document[0].body.scrollTop = 0; // For Safari
      $document[0].documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    $scope.commentSend = function() {
      if($scope.commentArgs.name==null || $scope.commentArgs.email==null || $scope.commentArgs.comment==null) {
        alert('Please complete all the boxes to send a comment');
        return false;
      }
      $scope.commentArgs.show = false;
      var dest = $scope.miscSettings.comments_form_email;
      var msg = "Name: "+$scope.commentArgs.name+"\n\n"+"Email: "+$scope.commentArgs.email+"\n\n"+"GDPR Consent: "+$scope.commentArgs.gdpr+"\n\n"+"Comment/Suggestion: "+"\n"+$scope.commentArgs.comment;
      var subject = "User comment on MEAT THE GRADE page: "+$scope.currPage.name;
      document.location.href = "mailto:"+dest+"?subject="
        + encodeURIComponent(subject)
        + "&body=" + encodeURIComponent(msg);

      $scope.commentArgs.comment = null;
    }

    var setCurModel = function(val) {
      const fType = "fbx";
      const fPath = "obj";
      const beast = $scope.curNavState.beast;
      const capB = beast.charAt(0).toUpperCase() + beast.slice(1);
      const sel = $scope.curNavState.gridSel[$scope.curNavState.beast].toUpperCase();
      var modArgs = {
        loaded:false,
        id: capB+" "+sel,
        name: capB+" "+sel,
        path: fPath+"/"+capB+"_"+sel+"."+fType
      };
      $scope.curNavState.model = Object.assign(modArgs,$scope.set3d.defaultModelSettings[$scope.curNavState.beast]);
      //$scope.curNavState.model.loaded = {complete: false, progress: 0};
      //console.log($scope.curNavState.model);
    }

    $scope.webgl_detect = true;

    $scope.makeSliderKeyList = function(keys) {
      const len = keys.length;
      var kl = [];
      for(var i=0;i<len;i++) {
        var ktmp = {
          pos: Math.round(i*100/(len - 1)),
          label:keys[i]
        }
        kl.push(ktmp);
      }
      return kl;
    };


        apiSvce.getJson('data/','settings.json')
        .then(function(response) {
          $scope.settings = response.data;
          $scope.svgArgs = $scope.settings.svg_args;
          $scope.miscSettings = $scope.settings.misc_settings;
          $scope.set3d = $scope.settings.set3d;
          $scope.gridNav = $scope.settings.gridNav;
          $scope.gridIntroText = $scope.settings.gridIntroText;
          $scope.pages = $scope.settings.pages
          $scope.handlingPts = $scope.settings.handling_points;
          $scope.assessPts = $scope.settings.assess_pt_set;
          $scope.sliderArgs = $scope.settings.defaultSliderArgs;
          $scope.sliderState = $scope.settings.defaultSliderState;

		      preLoader.preloadImages( $scope.settings.preLoad.img );

          //$scope.preLoadModels( $scope.settings.preLoad.models );

          $scope.$watch('navActive',function() {
            var cpIdx = arraySvce.arrIndexOf($scope.pages,$rootScope.navActive,'target');
            $scope.curViewState.navbarCollapsed = true;
            if(cpIdx > -1) {
              $scope.currPage = {pgIdx:cpIdx};
              Object.assign($scope.currPage,  $scope.pages[cpIdx]);
            };
            $scope.getViewDimensions();
          });

          $scope.$watch("curNavState",function(val) {
            locStore.sessionSet("curNavState",val);
            console.log("Stored session data")
          },true);

          $scope.$watch("curNavState.gridSel",function(val) {
            setCurModel(val);
          },true);

          $scope.$watch("curNavState.beast",function(val) {
            setCurModel(val);
          });

        })
        .then(
          //
        );


    $scope.winSize = {
			w: $window.innerWidth,
			h: $window.innerHeight,
      bodyHeight: $document[0].body.scrollHeight,
      viewPortHeight: Math.max($document[0].documentElement.clientHeight, $window.innerHeight || 0),
      bodyBounds: $document[0].body.getBoundingClientRect()
		};

		var getViewBounds = function() {
			$scope.winSize.viewPortHeight = Math.max($document[0].documentElement.clientHeight, $window.innerHeight || 0);
			$scope.winSize.bodyBounds = $document[0].body.getBoundingClientRect();
      console.log($scope.winSize.viewPortHeight+' '+$scope.winSize.bodyBounds.height+' '+$scope.winSize.bodyHeight);
		  $scope.curViewState.stickyFooter = ($scope.winSize.viewPortHeight > $scope.winSize.bodyBounds.height) ? true :false;
		}

    $scope.getViewDimensions = function() {
        $scope.winSize.w = $window.innerWidth;
        $scope.winSize.h = $window.innerHeight;
        $scope.winSize.bodyHeight = $document[0].body.scrollHeight;
        $scope.winSize.viewPortHeight = Math.max($document[0].documentElement.clientHeight, $window.innerHeight || 0);
  			$scope.winSize.bodyBounds = $document[0].body.getBoundingClientRect();
        $scope.curViewState.stickyFooter = ($scope.winSize.viewPortHeight > $scope.winSize.bodyHeight) ? true :false;
        //console.log($scope.winSize.viewPortHeight+' '+$scope.winSize.bodyBounds.height+' '+$scope.winSize.bodyHeight);
    }

		angular.element($window).bind('resize', function () {
      $scope.getViewDimensions();
      $scope.$apply();
		});

		$scope.styleWinHeight = {
			height: $scope.winSize.h
		}

		angular.element($window).bind('scroll', function () {
			$scope.getViewDimensions();
      $scope.$apply();
		});


		$scope.onExit = function() {
			//
		};

   	$window.onbeforeunload =  $scope.onExit;

		//Initialise scope vars

		$scope.goBack = function() {
			$window.history.back();
		}

		$scope.status = {
			msg: "App is running",
			init: false,
      content_loaded: false
		};

		$scope.imgPath = 'img/';

    $scope.toggleOpacity = function(id) {
      var idx = arraySvce.arrIndexOf($scope.objList,id,'id');
      if(idx > -1) {
          $scope.objList[idx].models.forEach(function(obj,i) {
            obj.opacity = obj.opacity == 0 ? 1 : 0;
          });
      }
    }

		//INITIALISE APP

		$scope.initApp = function() {
			console.log('Initialising APP');
			$scope.status.init = true;
		}

    $scope.$on('$viewContentLoaded', function(){
      $scope.getViewDimensions();
    });

    //Cleanup

    $scope.$on("$destroy", function() {
      angular.element($window).unbind('resize');
      angular.element($window).unbind('scroll');
    });

	}])



// WEBPACK FOOTER //
// ./src/app/js/qms.controllers.js